"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (dispatcher, actionType) {
  return function Action(payload, context) {
    dispatcher.dispatch({
      actionType: actionType,
      payload: payload,
      context: context
    });

    // so we have something to return in a promise
    return true;
  };
};


//////////////////
// WEBPACK FOOTER
// ./action-factory/index.js
// module id = 204
// module chunks = 0